import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {MenuEditComponent} from "app/pages/menu-edit/menu-edit.component";
import {ModifierGroupComponent} from './modifier-group/modifier-group.component';
import {TranslateModule} from "@ngx-translate/core";
import { ModifierGroupItemComponent } from './modifier-group/modifier-group-item/modifier-group-item.component';
import { ModifierGroupModalComponent } from './modifier-group/modifier-group-modal/modifier-group-modal.component';
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { SelectModifiersModalComponent } from './modifier-group/select-modifiers-modal/select-modifiers-modal.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import {PreloaderModule} from "app/components/preloader/preloaderModule";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { PromoComponent } from './promo/promo.component';
import { ProductCardComponent } from './promo/product-card/product-card.component';
import {DragDropModule} from "@angular/cdk/drag-drop";
import {MenuModule} from "app/pages/menu/menu.module";
import { MatMenuModule } from '@angular/material/menu';
import {MatTabsModule} from "@angular/material/tabs";
import { AllergenGroupsComponent } from './allergen-groups/allergen-groups.component';
import { AllergenGroupFormComponent } from './allergen-groups/allergen-group-form/allergen-group-form.component';
import {SharedModule} from "app/shared/shared.module";
import { DefaultImagesComponent } from './default-images/default-images.component';
import { RpProgramsComponent } from './rp-programs/rp-programs.component';

const routes: Routes = [
  {
    path: '',
    component: MenuEditComponent,
    children: [
      {path: 'modifier-group', component: ModifierGroupComponent, pathMatch: 'full'},
      {path: 'promo', component: PromoComponent, pathMatch: 'full'},
      {path: 'allergen-groups', component: AllergenGroupsComponent, pathMatch: 'full'},
      {path: 'default-images', component: DefaultImagesComponent, pathMatch: 'full'},
      {path: 'rp-programs', component: RpProgramsComponent, pathMatch: 'full'},
    ]
  },
];

@NgModule({
  declarations: [
    ModifierGroupComponent,
    ModifierGroupItemComponent,
    ModifierGroupModalComponent,
    SelectModifiersModalComponent,
    PromoComponent,
    ProductCardComponent,
    AllergenGroupsComponent,
    AllergenGroupFormComponent,
    DefaultImagesComponent,
    RpProgramsComponent
  ],
  exports: [
    ModifierGroupComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    MatIconModule,
    MatFormFieldModule,
    MatDialogModule,
    MatCheckboxModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatTooltipModule,
    PreloaderModule,
    MatProgressSpinnerModule,
    DragDropModule,
    MenuModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatTabsModule,
    SharedModule,
  ]
})
export class MenuEditModule {
}
